/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import BufferCalculationHeader from './bufferCalculationHeader';
import BufferCalculationItem from './bufferCalculationItem';
import { useSnackbar } from '../../../Components/Snackbar/snackBarProvider';
import { saveTechBuffer, saveExternalIntegrationBuffer, saveClarityBuffer,saveFrontEndBuffer, getFrontEndBuffer, updateFrontEndBuffer, getClarityBuffer, getExternalIntegrationBuffer, getTechBuffer, updateClarityBuffer, updateExternalIntegrationBuffer, updateTechBuffer,deleteBuffer } from '../../../Api/request/effortMaster';
import UseAxios from '../../../Api/http/http';
import { AuthContext } from '../../../Contexts/AuthContext';
import { MODULE_NAMES } from '../../../Constants/modules';
import PuzzleLoader from '../../../Assets/images/svg/loading puzzle.gif';

const BufferCalculation = () => {
  const [timeUnits] = useState(['Hour', 'Day', 'Week']);
  const [baseData, setBaseData] = useState([]);
  const { snackbarOpen } = useSnackbar();
  const [openAccordionId, setOpenAccordionId] = useState([]);
  const [operationType,setOperationType] = useState('insert')
  const [isLoading, setIsLoading] = useState(true);
  const { userProfile } = useContext(AuthContext);

  const permission = userProfile?.permissions
  ? userProfile.permissions[MODULE_NAMES.MASTER_DEAL_EFFORTS] || []
  : [];

  const hasAccess = (action) => {
    return permission.includes(action);
  };

  const fetchData = async () => {
    try {
      const [techResponse, clarityResponse, integrationResponse, frontEndResponse] = await Promise.all([
        UseAxios(getTechBuffer('tech', true)),
        UseAxios(getClarityBuffer('clarity', true)),
        UseAxios(getExternalIntegrationBuffer('integration', true)),
        UseAxios(getFrontEndBuffer('front end', true)),
      ]);
      const fetchedData = [
        {
          id: 1,
          title: 'Technical Complexity',
          options: techResponse?.data?.data?.techEffort.map((item, index) => ({
            id: item.id,
            name: item.name,
            value: item.value,
            unit_type: item.unit_type,
            edit: false,
          })) || [],
        },
        {
          id: 2,
          title: 'Requirement Clarity',
          options: clarityResponse?.data?.data?.clarityEffort.map((item, index) => ({
            id: item.id,
            name: item.name,
            value: item.value,
            unit_type: item.unit_type,
            edit: false,
          })) || [],
        },
        {
          id: 3,
          title: '3rd Party External Integration',
          options: integrationResponse?.data?.data?.externalIntegrationEffort.map((item, index) => ({
            id: item.id,
            name: item.name,
            value: item.value,
            unit_type: item.unit_type,
            edit: false,
          })) || [],
        },
        {
          id: 4,
          title: 'Front End',
          options: frontEndResponse?.data?.data?.baseEffort.map((item, index) => ({
            id: item.id,
            name: item.name,
            value: item.value,
            unit_type: item.unit_type,
            edit: false,
          })) || [],
        },
      ];
      setBaseData(fetchedData);
    } catch (error) {
      console.error('Error fetching data:', error);
      snackbarOpen('Failed to fetch buffer data', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const toggleAccordion = (id) => {
    setOpenAccordionId((prevIds) =>
      prevIds.includes(id)
        ? prevIds.filter((prevId) => prevId !== id) 
        : [...prevIds, id],
    );
  };
 
  const addEfforts = (itemId) => {
    setBaseData((prevData) =>
      prevData.map((item) => {
        if (item.id === itemId && item.options?.length >= 4) {
          return item; 
        }
  
        return item.id === itemId
          ? {
              ...item,
              options: [
                ...((Array.isArray(item.options) && item.options) || []),
                {
                  id: item.options?.length + 1,
                  name: '',
                  value: '0',
                  unit_type: 'Day',
                  edit: true, 
                },
              ],
            }
          : item;
      })
    );
    setOperationType('insert');
  };
  // Helper function for editAllEfforts
  const updateAllEditOptions = (prevData) => {
    return prevData.map((item) => ({
      ...item,
      options: item.options.map((option) => ({
        ...option,
        edit: true, // Set the 'edit' property to true for all options
      })),
    }));
  };

  const editAllEfforts = () => {
    setBaseData((prevData) => updateAllEditOptions(prevData));

    // Open all accordions
    setOpenAccordionId(baseData.map((item) => item.id));
  };


  // Helper function for editEfforts
  const updateOptionEditStatus = (options, optionId) => {
    return options.map((option) =>
      option.id === optionId ? { ...option, edit: true } : option,
    );
  };

  const editEfforts = (itemId, optionId) => {
    setOperationType('update');
    setBaseData((prevData) =>
      prevData.map((item) =>
        item.id === itemId
          ? { ...item, options: updateOptionEditStatus(item.options, optionId) }
          : item,
      ),
    );
  };

  const apiMapping = {
    tech: {
      insert: saveTechBuffer,
      update: updateTechBuffer,
    },
    integration: {
      insert: saveExternalIntegrationBuffer,
      update: updateExternalIntegrationBuffer,
    },
    clarity: {
      insert: saveClarityBuffer,
      update: updateClarityBuffer,
    },
    'front end': {
      insert: saveFrontEndBuffer,
      update: updateFrontEndBuffer,
    },
  };

  const handleEffortSaveOrUpdate = async (operationType, itemId, optionId) => { 
    const item = baseData.find((item) => item.id === itemId);
    if (!item) return;
  
    const optionToSave = item.options.find((option) => option.id === optionId);
    if (!optionToSave) return;
  
    const isDuplicatePriority = item.options.some(
      (option) =>
        option.id !== optionId &&
        option.name.toLowerCase() === optionToSave.name.toLowerCase()
    );
  
    if (isDuplicatePriority) {
      snackbarOpen(`Duplicate ${item.title} entry cannot be added`, 'warning');
      return; 
    }
  
    setBaseData((prevData) => updateBaseData(prevData, itemId, optionId));

    const updateBaseData = (prevData, itemId, optionId) => {
      return prevData.map((item) =>
        item.id === itemId
          ? { ...item, options: updateOptions(item.options, optionId) }
          : item
      );
    };
    
    const updateOptions = (options, optionId) => {
      return options.map((option) =>
        option.id === optionId ? { ...option, edit: false } : option
      );
    };
  
    try {
      const { name, value, unit_type, id } = optionToSave;
  
      let type = '';
      switch (item.title) {
        case 'Technical Complexity':
          type = 'tech';
          break;
        case '3rd Party External Integration':
          type = 'integration';
          break;
        case 'Requirement Clarity':
          type = 'clarity';
          break;
        case 'Front End':
          type = 'front end';
          break;
      }
  
      const payload = {
        name,
        value,
        unit_type,
        type,
        is_active: 'true',
        ...(operationType === 'update' && { id }),
      };

      const apiFunction = apiMapping[type]?.[operationType];
      if (apiFunction) {
        await UseAxios(apiFunction(payload));
        fetchData();
      } else {
        console.error('Invalid operation type or API function not found');
      }
    } catch (error) {
      console.error('Error during API call:', error);
    }
  };
  
  
  const saveEffort = (itemId, optionId) => {
    handleEffortSaveOrUpdate(operationType, itemId, optionId);
  };


  // Scoped delete function

  //  Helper function for deleteEffort
  const removeOptionById = (options, optionId) => {
    return options.filter((option) => option.id !== optionId);
  };

  const deleteEffort =async (itemId, optionId) => {
    try {
      await UseAxios(deleteBuffer(optionId))
    } catch (error) {
      console.error('Error deleting effort:', error.message || error);
    }
    setBaseData((prevData) =>
      prevData.map((item) =>
        item.id === itemId
          ? { ...item, options: removeOptionById(item.options, optionId) }
          : item,
      ),
    );
  };

  //  Helper function for handleFieldChange
  const updateOptionField = (options, optionId, field, value) => {
    return options.map((option) =>
      option.id === optionId ? { ...option, [field]: value } : option,
    );
  };

  const handleFieldChange = (itemId, optionId, field, value) => {
    setBaseData((prevData) =>
      prevData.map((item) =>
        item.id === itemId
          ? { ...item, options: updateOptionField(item.options, optionId, field, value) }
          : item,
      ),
    );
  };


  // Scoped increment/decrement functionality

  // Helper function for handleIncrement
  const handleIncrementForOption = (item, optionId) => {
    return {
      ...item,
      options: item.options.map((option) =>
        option.id === optionId
          ? { ...option, value: (Number(option.value) + 1).toString() }
          : option,
      ),
    };
  };

  const handleIncrement = (itemId, optionId) => {
    setBaseData((prevData) =>
      prevData.map((item) =>
        item.id === itemId ? handleIncrementForOption(item, optionId) : item,
      ),
    );
  };


  // Helper function for handleDecrement
  const handleDecrementForOption = (item, optionId) => {
    return {
      ...item,
      options: item.options.map((option) =>
        option.id === optionId
          ? {
            ...option,
            value: Math.max(0, Number(option.value) - 1).toString(),
          }
          : option,
      ),
    };
  };

  const handleDecrement = (itemId, optionId) => {
    setBaseData((prevData) =>
      prevData.map((item) =>
        item.id === itemId ? handleDecrementForOption(item, optionId) : item,
      ),
    );
  };


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <img src={PuzzleLoader} alt="Loading..." style={{ width: '100px', height: 'auto' }}/>
      </div>
    );
  }

  return (
    <div>
      <BufferCalculationHeader editAllEfforts={editAllEfforts}  hasAccess={hasAccess} />
      {baseData.map((item) => (
        <BufferCalculationItem
          key={item.id}
          item={item}
          openAccordionId={openAccordionId}
          toggleAccordion={toggleAccordion}
          addEfforts={addEfforts}
          handleFieldChange={handleFieldChange}
          handleIncrement={handleIncrement}
          handleDecrement={handleDecrement}
          saveEffort={saveEffort}
          deleteEffort={deleteEffort}
          editEfforts={editEfforts}
          timeUnits={timeUnits}
          hasAccess={hasAccess} 
        />
      ))}
    </div>
  );
};

export default BufferCalculation;
